export const SUBSCRIPTION_PLANS = {
    FREE:          'FREE',
    TOP_PLAN:      'TOP_PLAN',
    PAY_AS_YOU_GO: 'PAY_AS_YOU_GO',
    // Legacy names kept for backward-compat with existing subscriptions
    BASIC:         'BASIC',
    PRO:           'PRO',
    ADVANCED:      'ADVANCED',
    ENTERPRISE:    'ENTERPRISE',
};

export const PlanPriority = Object.freeze({
    FREE:          0,
    TOP_PLAN:      1,
    PAY_AS_YOU_GO: 2,
    // Legacy
    BASIC:         1,
    PRO:           2,
    ADVANCED:      3,
    ENTERPRISE:    7,
    BASIC_YEARLY:  4,
    PRO_YEARLY:    5,
    ADVANCED_YEARLY: 6,
});

export const YEARLY_DISCOUNT_PERCENTAGE = 17;

export const calculateYearlyPrice = (monthlyPrice, planName) => {
    if (planName === SUBSCRIPTION_PLANS.FREE) return 0;
    return Math.round(monthlyPrice * 12 * (1 - 0.17));
};

export const getPlanPriority = (planName) => {
    if (!planName) return 0;
    return PlanPriority[planName.toUpperCase()] || 0;
};

/** Price of the TOP_PLAN in INR (matches backend constant TOP_PLAN_CREDITS_INR). */
export const TOP_PLAN_PRICE_INR = 2000;
/** Credits bundled in the TOP_PLAN (matches backend TOP_PLAN_CREDITS). */
export const TOP_PLAN_CREDITS   = 2000;
/** Free plan credits (matches backend FREE_PLAN_CREDITS). */
export const FREE_PLAN_CREDITS  = 500;
/** 1 USD = 100 INR — used for display price conversion only. */
export const INR_PER_USD        = 100;

export const CREDIT_TOOLTIP = '1 credit ≈ 1 chat query on standard model';

// UI-only display metadata keyed by plan_type (label + billing period)
export const PLAN_DISPLAY = {
    FREE:          { label: 'Free',       period: 'One Time'  },
    TOP_PLAN:      { label: 'Pro',        period: 'per month' },
    PAY_AS_YOU_GO: { label: 'Enterprise', period: ''          },
};

// Fallback features shown when the DB entry has no features array
export const POSTPAID_FALLBACK_FEATURES = [
    'Unlimited* usage',
    'All AI models (GPT, Gemini…)',
    'Full usage analytics',
    'Detailed monthly invoice',
    'Actual + margin cost breakdown',
    'Per-user seat fee: configurable',
];

// Top-up rate: $1 = 100 credits. Only purchasable on an active Pro (TOP_PLAN) subscription.
export const TOPUP_MIN_CREDITS  = 100;
export const TOPUP_STEP_CREDITS = 100;
